<template>
	<section class="view-ui-icon-tv">
		<svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M31.414 0H1.10508C0.494772 0 0 0.494772 0 1.10508V17.5787C0 18.189 0.494772 18.6838 1.10508 18.6838H31.414C32.0243 18.6838 32.519 18.189 32.519 17.5787V1.10508C32.519 0.494772 32.0243 0 31.414 0Z"
				fill="currentColor"
			/>
			<path
				d="M22.5743 22.0828H18.8226V20.601H13.6965V22.0828H9.94476C9.41537 22.0828 8.98615 22.512 8.98615 23.0414C8.98615 23.5708 9.41531 24 9.94476 24H22.5743C23.1037 24 23.5329 23.5709 23.5329 23.0414C23.5329 22.512 23.1037 22.0828 22.5743 22.0828Z"
				fill="currentColor"
			/>
		</svg>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Icon
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiIconTV extends ViewBase {
		// Not implemented
	}
</script>
